import type { IAppState } from 'services/app-state-provider';
import { deserializeVisitedPages } from 'services/socket-lc3/chat/serialization/deserialize-customer-visited-pages';
import { CustomerActions } from 'store/entities/customers/actions';

import { type IIncomingCustomersPushEvent } from '../interfaces';
import { deserializeIncomingCustomerPushEvent } from '../serialization/deserialize';

export const handleIncomingCustomers = (payload: IIncomingCustomersPushEvent, store: IAppState): void => {
  const customersData = payload.customers.reduce(
    (acc, customer) => {
      // v3.6 visit or v3.5 last_visit
      const lastVisitData = customer.visit ?? customer.last_visit;

      acc.customers[customer.id] = deserializeIncomingCustomerPushEvent(customer);
      acc.visitedPages[customer.id] = deserializeVisitedPages(lastVisitData);

      return acc;
    },
    { customers: {}, visitedPages: {} },
  );

  store.dispatch(CustomerActions.addOrUpdateCustomers(customersData));
};
